<div class="nxe-menu-bar">
  <div class="nxe-menu-bar-left" role="toolbar" [attr.aria-label]="'filemanager.ui.toolbar' | translate">
    @if (featCreateDir) {
      <button type="button" class="xr-btn xr-btn--secondary nxe-menu-bar-button create-folder-icon" (click)="createDir()"
              [attr.aria-label]="'filemanager.ui.new_folder' | translate"
              [matTooltip]="'filemanager.ui.new_folder' | translate" matTooltipPosition="above">
        <i-tabler name="folder-plus" class="icon-18"></i-tabler>
        <span class="label">{{ 'filemanager.ui.new_folder' | translate }}</span>
      </button>
    }

    <button type="button" class="xr-btn xr-btn--secondary nxe-menu-bar-button refresh-icon" (click)="refresh()"
            [attr.aria-label]="'filemanager.ui.refresh' | translate"
            [matTooltip]="'filemanager.ui.refresh' | translate" matTooltipPosition="above">
      <i-tabler name="refresh" class="icon-18"></i-tabler>
      <span class="label">{{ 'filemanager.ui.refresh' | translate }}</span>
    </button>

    @if (featUpload) {
      <button type="button" class="xr-btn xr-btn--primary nxe-menu-bar-button upload-icon" (click)="openUploader()"
              [attr.aria-label]="'filemanager.ui.upload' | translate"
              [matTooltip]="'filemanager.ui.upload' | translate" matTooltipPosition="above">
        <i-tabler name="upload" class="icon-18"></i-tabler>
        <span class="label">{{ 'filemanager.ui.upload' | translate }}</span>
      </button>
    }
  </div>
  <div class="nxe-menu-bar-right">
    @if (showSwitcher) {
      <nxe-view-switcher></nxe-view-switcher>
    }
  </div>

  <!-- Barra blu notte delle azioni: compare solo quando c'è una selezione.
       Ogni azione resta nascosta se non è consentita per gli elementi selezionati. -->
  @if (selection$ | async; as selection) {
    @if (selection.length > 0) {
      <div class="nxe-selection-bar" role="toolbar" [attr.aria-label]="'filemanager.ui.selection_actions' | translate">
        <div class="nxe-selection-name" [title]="selectionLabel(selection)">
          <i-tabler [name]="selection.length === 1 && !selection[0].isLeaf ? 'folder' : 'file'" class="icon-18" aria-hidden="true"></i-tabler>
          <span>{{ selectionLabel(selection) }}</span>
        </div>
        <div class="nxe-selection-actions">
          @if (canOpenFolder$ | async) {
            <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn open-icon" (click)="openFolder()"
                    [attr.aria-label]="'filemanager.ui.open' | translate"
                    [matTooltip]="'filemanager.ui.open' | translate" matTooltipPosition="above">
              <i-tabler name="folder-open" class="icon-18"></i-tabler>
              <span class="label">{{ 'filemanager.ui.open' | translate }}</span>
            </button>
          }

          @if (featViewFile && (canView$ | async)) {
            <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn view-icon" (click)="viewFile()"
                    [attr.aria-label]="'filemanager.ui.view_file' | translate"
                    [matTooltip]="'filemanager.ui.view_file' | translate" matTooltipPosition="above">
              <i-tabler name="eye" class="icon-18"></i-tabler>
              <span class="label">{{ 'filemanager.ui.view_file' | translate }}</span>
            </button>
          }

          @if (featDownload && (canDownload$ | async)) {
            <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn download-icon" (click)="download()"
                    [attr.aria-label]="'filemanager.ui.download' | translate"
                    [matTooltip]="'filemanager.ui.download' | translate" matTooltipPosition="above">
              <i-tabler name="download" class="icon-18"></i-tabler>
              <span class="label">{{ 'filemanager.ui.download' | translate }}</span>
            </button>
          }

          @if (featRename && (canRename$ | async)) {
            <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn edit-icon" (click)="rename()"
                    [attr.aria-label]="'filemanager.ui.rename' | translate"
                    [matTooltip]="'filemanager.ui.rename' | translate" matTooltipPosition="above">
              <i-tabler name="edit" class="icon-18"></i-tabler>
              <span class="label">{{ 'filemanager.ui.rename' | translate }}</span>
            </button>
          }

          @if (featSendFile && showSendFile) {
            @if (canSendFile$ | async) {
              <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn send-icon" (click)="sendFile()"
                      [attr.aria-label]="'filemanager.ui.send_file' | translate"
                      [matTooltip]="'filemanager.ui.send_file' | translate" matTooltipPosition="above">
                <i-tabler name="file-export" class="icon-18"></i-tabler>
                <span class="label">{{ 'filemanager.ui.send_file' | translate }}</span>
              </button>
            }
          }
          @else if (featSendFile && showEditFile) {
            @if (canEditFile$ | async) {
              <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn send-icon" (click)="editFile()"
                      [attr.aria-label]="'filemanager.ui.edit_file' | translate"
                      [matTooltip]="'filemanager.ui.edit_file' | translate" matTooltipPosition="above">
                <i-tabler name="photo-edit" class="icon-18"></i-tabler>
                <span class="label">{{ 'filemanager.ui.edit_file' | translate }}</span>
              </button>
            }
          }

          @if (featDelete && (canDelete$ | async)) {
            <button type="button" class="xr-btn nxe-menu-bar-button nxe-sel-btn nxe-sel-btn--danger delete-icon" (click)="remove()"
                    [attr.aria-label]="'filemanager.ui.delete' | translate"
                    [matTooltip]="'filemanager.ui.delete' | translate" matTooltipPosition="above">
              <i-tabler name="trash" class="icon-18"></i-tabler>
              <span class="label">{{ 'filemanager.ui.delete' | translate }}</span>
            </button>
          }

          <button type="button" class="xr-btn xr-btn--icon nxe-sel-btn nxe-sel-close" (click)="clearSelection()"
                  [attr.aria-label]="'filemanager.ui.clear_selection' | translate"
                  [matTooltip]="'filemanager.ui.clear_selection' | translate" matTooltipPosition="above">
            <i-tabler name="x" class="icon-18"></i-tabler>
          </button>
        </div>
      </div>
    }
  }
  <input style="display: none" type="file" multiple (change)="handleFiles($event)" #uploader/>
</div>
